import edapWrapper from '@homeaway/edap-wrapper';
export const edap = edapWrapper();

export const GENERIC_EVENT = 'generic.event';
export const PAGE_VIEW = 'pageview';


export const namedEvents = {
    HEADER_LINK_CLICK: 'header.link.click',
    TRIP_COLLECTION_SELECTED: 'trip_collection.selected'
};

export const linkLocations = {
    HEADER_LINK_LOGIN: 'header.login',
    HEADER_LINK_OWNER_LOGIN: 'header.login.owner',
    HEADER_LINK_TRAVELER_LOGIN: 'header.login.traveler'
};
